import {
	nextChangeTaskGroupParent as changeTaskGroupParent,
	nextGoBackToPreviousTaskGroup as goBackToPreviousTaskGroup,
} from './next-task-group/index.tsx';

import { setIsOpen } from './checklist-open/index.tsx';

import { refreshAppState } from './refresh-app-state/index.tsx';

import { setNudgeStep } from './nudge-step/index.tsx';

import { addMountedNudge, removeMountedNudge } from './mounted-nudges/index.tsx';

import { setShouldRenderComponent } from './should-render-component/index.tsx';

import { setProjectState } from './set-project-state/index.tsx';

import { setHasNudgeActive } from './set-has-nudge-active/index.tsx';

import { forceHideNudge } from './force-hide-nudge/index.tsx';

import { setHasEverSeenRoute } from './has-ever-seen-route/index.tsx';

import { setRoadmapIsCreateEnabled, setRoadmapIsListEmpty } from './roadmap-state/index.tsx';

import { openNextTask } from './open-next-task/index.tsx';

import { resetIsQuickstartLoaded } from './reset-is-quickstart-loaded/index.tsx';

import { refreshAppStateUiStatusOnly } from './refresh-app-state-ui-status-only/index.tsx';

import { nextMarkAsCompletedTask } from './next-complete-task/index.tsx';

import { nextSetChecklistItemSeen } from './next-set-checklist-item-seen/index.tsx';

import { nextSetChecklistIsDismissed } from './next-checklist-dismiss/index.tsx';

import { nextSetChecklistIsOpen } from './next-checklist-open/index.tsx';

import { nextOpenTask } from './next-open-task/index.tsx';

import { nextAutoExpand } from './next-auto-expand/index.tsx';

import { nextShouldShowNudgeAfterNavigation } from './next-should-show-nudge-after-navigation/index.tsx';

import { nextGetTasks } from './next-tasks/index.tsx';

import { syncVisibilityWithLocal } from './sync-visibility-with-local/index.tsx';

import { universalDispatch } from './universal-dispatch/index.tsx';

// Note: Moving forward, stop adding new actions to this object.
// Instead, define any new actions needed in "./disconnected-actions" instead
// Then, at the call site, only use the universalDispatch action and pass the disconnected action.
// The future should look to refactor the actions object down to only the universalDispatch action.
export const actions = {
	changeTaskGroupParent,
	goBackToPreviousTaskGroup,
	setIsOpen,
	refreshAppState,
	setNudgeStep,
	addMountedNudge,
	removeMountedNudge,
	setShouldRenderComponent,
	setProjectState,
	setHasNudgeActive,
	forceHideNudge,
	setHasEverSeenRoute,
	setRoadmapIsCreateEnabled,
	setRoadmapIsListEmpty,
	openNextTask,
	resetIsQuickstartLoaded,
	refreshAppStateUiStatusOnly,
	nextMarkAsCompletedTask,
	nextSetChecklistItemSeen,
	nextSetChecklistIsDismissed,
	nextSetChecklistIsOpen,
	nextOpenTask,
	nextAutoExpand,
	nextShouldShowNudgeAfterNavigation,
	nextGetTasks,
	syncVisibilityWithLocal,
	universalDispatch,
};
